import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { IAdSetupFactory } from 'tag/ts/tag/interfaces/ads/IAdSetupFactory';
import { IAdSetupInfo } from 'tag/ts/tag/interfaces/ads/IAdSetupInfo';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';
import { AdSDK } from 'tag/ts/tag/model/type/ads/AdSDK';
import { AdSetupDefinition } from 'tag/ts/tag/model/type/ads/AdSetupDefinition';

/**
 * @copyright © Paramount Streaming
 * @author  Zeeshan Ahmad
 * @description Base class for all factory classes used to create instances of IAdSetupInfo
 */
export abstract class AbstractAdSetupFactory extends AbstractTagClass implements IAdSetupFactory {

	protected constructor( argument: ITagAbstractClassArgument ) {
		super(
			{
				name: 'AbstractAdSetupFactory',
				...argument
			}
		);
	}

	/**
	 * @description Returns a complex object representing ad setup
	 * @returns IAdSetupInfo
	 */
	abstract createAdSetupInfo(): IAdSetupInfo;

	/**
	 * @description Returns an ad setup object which does not require ads
	 * @returns {IAdSetupInfo}
	 */
	protected createDefaultAdSetupInfo(): IAdSetupInfo {
		return <IAdSetupInfo>{
			sdk: {
				module: undefined,
				type: AdSDK.NONE
			},
			setup: {
				type: undefined,
				definition: AdSetupDefinition.NONE
			}
		};
	}
}